import React from 'react';
import './WorldSelector.css';

function WorldSelector({ worlds, currentWorld, onSelectWorld }) {
    return (
        <div className="world-selector">
            <div className="world-tabs">
                {worlds.map((world, index) => (
                    <button
                        key={world.worldNumber}
                        className={`world-tab ${index === currentWorld ? 'active' : ''} ${!world.unlocked ? 'locked' : ''} ${world.completed ? 'completed' : ''}`}
                        onClick={() => onSelectWorld(index)}
                        disabled={!world.unlocked}
                        title={world.unlocked ? world.name : 'Complete previous world to unlock'}
                    >
                        <span className="tab-emoji">{world.themeEmoji}</span>
                        <span className="tab-number">{world.worldNumber}</span>

                        {/* Completion indicator */}
                        {world.completed && (
                            <span className="tab-complete">✓</span>
                        )}

                        {/* Lock indicator */}
                        {!world.unlocked && (
                            <span className="tab-lock">🔒</span>
                        )}

                        {/* Progress indicator */}
                        {world.unlocked && !world.completed && (
                            <div className="tab-progress">
                                <div
                                    className="tab-progress-fill"
                                    style={{
                                        width: `${(world.nodes.filter(n => n.completed).length / world.nodes.length) * 100}%`
                                    }}
                                />
                            </div>
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default WorldSelector;
